

export class EmployeeMonthlySalaryDto implements IEmployeeMonthlySalaryDto {
    id!: number;
    employeeId!: number;
    empName!: string | undefined;
    empCode!: string | undefined;
    salaryMonth!: Date | undefined;
    basicSalary!: number | undefined;
    absentDays!: number | undefined;
    absentSalary!: number | undefined;
    professionalTax!: number | undefined;
    netSalary!: number | undefined;
    extraDay!: number | undefined;
    extraDaySalary!: number | undefined;
    overtimeHours!: number | undefined;
    overtimeSalary!: number | undefined;
    extraPay!: number | undefined;
    finalSalary!: number | undefined;
    displayName!: string | undefined;
    designationName!: string | undefined;
    departmentName!: string | undefined;
    joinDate!: Date | undefined;
    payDate!: Date | undefined;
    workingDay!: number;
    employeeSalaryType!: number;
    paidLeaveCount!: number | undefined;
    paidLeaveAmount!: number | undefined;
    incrementAmount!: number | undefined;
    presentDays!: number | undefined;
    totalTDSAmount!: number | undefined;
    payableSalary!: number | undefined;
    additionalSalary!: number | undefined;
    empLegalName!: string | undefined;
    companyLegalName!: string | undefined;
    companyAddress!: string | undefined;
    basicAlw!: number | undefined;
    dearnessAlw!: number | undefined;
    houseRentAlw!: number | undefined;
    medicalAlw!: number | undefined;
    dailyTravellingAlw!: number | undefined;
    performanceAlw!: number | undefined;
    otherAlw!: number | undefined;
    productionAlw!: number | undefined;
    fuelAlw!: number | undefined;
    pfDetectable!: boolean;
    esicDetectable!: boolean;
    lwfDetectable!: boolean;
    ptDetectable!: boolean;
    pfGross!: number | undefined;
    esicGross!: number | undefined;
    ptGross!: number | undefined;
    lwfGross!: number | undefined;
    employeeEPFAmount!: number | undefined;
    employeeFPFAmount!: number | undefined;
    companyEPFAmount!: number | undefined;
    companyFPFAmount!: number | undefined;
    employeeESICAmount!: number | undefined;
    companyESICAmount!: number | undefined;
    employeeLWFAmount!: number | undefined;
    companyLWFAmount!: number | undefined;
    pfNo!: string | undefined;
    pfuan!: string | undefined;
    esicNo!: string | undefined;
    aadharNo!: string | undefined;
    pan!: string | undefined;
    paymentType!: string | undefined;
    bankName!: string | undefined;
    bankAccNo!: string | undefined;
    ifscCode!: string | undefined;
    advancePay!: number | undefined;
    isSalaryPaid!: boolean;
    paidAmount!: number | undefined;
    salaryCalcDays!: number | undefined;
    usedPaidLeaveCount!: number | undefined;

    constructor(data?: IEmployeeMonthlySalaryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.employeeId = _data["employeeId"];
            this.empName = _data["empName"];
            this.empCode = _data["empCode"];
            this.salaryMonth = _data["salaryMonth"] ? new Date(_data["salaryMonth"].toString()) : <any>undefined;
            this.basicSalary = _data["basicSalary"];
            this.absentDays = _data["absentDays"];
            this.absentSalary = _data["absentSalary"];
            this.professionalTax = _data["professionalTax"];
            this.netSalary = _data["netSalary"];
            this.extraDay = _data["extraDay"];
            this.extraDaySalary = _data["extraDaySalary"];
            this.overtimeHours = _data["overtimeHours"];
            this.overtimeSalary = _data["overtimeSalary"];
            this.extraPay = _data["extraPay"];
            this.finalSalary = _data["finalSalary"];
            this.displayName = _data["displayName"];
            this.designationName = _data["designationName"];
            this.departmentName = _data["departmentName"];
            this.joinDate = _data["joinDate"] ? new Date(_data["joinDate"].toString()) : <any>undefined;
            this.payDate = _data["payDate"] ? new Date(_data["payDate"].toString()) : <any>undefined;
            this.workingDay = _data["workingDay"];
            this.employeeSalaryType = _data["employeeSalaryType"];
            this.paidLeaveCount = _data["paidLeaveCount"];
            this.paidLeaveAmount = _data["paidLeaveAmount"];
            this.incrementAmount = _data["incrementAmount"];
            this.presentDays = _data["presentDays"];
            this.totalTDSAmount = _data["totalTDSAmount"];
            this.payableSalary = _data["payableSalary"];
            this.additionalSalary = _data["additionalSalary"];
            this.empLegalName = _data["empLegalName"];
            this.companyLegalName = _data["companyLegalName"];
            this.companyAddress = _data["companyAddress"];
            this.basicAlw = _data["basicAlw"];
            this.dearnessAlw = _data["dearnessAlw"];
            this.houseRentAlw = _data["houseRentAlw"];
            this.medicalAlw = _data["medicalAlw"];
            this.dailyTravellingAlw = _data["dailyTravellingAlw"];
            this.performanceAlw = _data["performanceAlw"];
            this.otherAlw = _data["otherAlw"];
            this.productionAlw = _data["productionAlw"];
            this.fuelAlw = _data["fuelAlw"];
            this.pfDetectable = _data["pfDetectable"];
            this.esicDetectable = _data["esicDetectable"];
            this.lwfDetectable = _data["lwfDetectable"];
            this.ptDetectable = _data["ptDetectable"];
            this.pfGross = _data["pfGross"];
            this.esicGross = _data["esicGross"];
            this.ptGross = _data["ptGross"];
            this.lwfGross = _data["lwfGross"];
            this.employeeEPFAmount = _data["employeeEPFAmount"];
            this.employeeFPFAmount = _data["employeeFPFAmount"];
            this.companyEPFAmount = _data["companyEPFAmount"];
            this.companyFPFAmount = _data["companyFPFAmount"];
            this.employeeESICAmount = _data["employeeESICAmount"];
            this.companyESICAmount = _data["companyESICAmount"];
            this.employeeLWFAmount = _data["employeeLWFAmount"];
            this.companyLWFAmount = _data["companyLWFAmount"];
            this.pfNo = _data["pfNo"];
            this.pfuan = _data["pfuan"];
            this.esicNo = _data["esicNo"];
            this.aadharNo = _data["aadharNo"];
            this.pan = _data["pan"];
            this.paymentType = _data["paymentType"];
            this.bankName = _data["bankName"];
            this.bankAccNo = _data["bankAccNo"];
            this.ifscCode = _data["ifscCode"];
            this.advancePay = _data["advancePay"];
            this.isSalaryPaid = _data["isSalaryPaid"];
            this.paidAmount = _data["paidAmount"];
            this.salaryCalcDays = _data["salaryCalcDays"];
            this.usedPaidLeaveCount = _data["usedPaidLeaveCount"];
        }
    }

    static fromJS(data: any): EmployeeMonthlySalaryDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeMonthlySalaryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["employeeId"] = this.employeeId;
        data["empName"] = this.empName;
        data["empCode"] = this.empCode;
        data["salaryMonth"] = this.salaryMonth ? this.salaryMonth.toISOString() : <any>undefined;
        data["basicSalary"] = this.basicSalary;
        data["absentDays"] = this.absentDays;
        data["absentSalary"] = this.absentSalary;
        data["professionalTax"] = this.professionalTax;
        data["netSalary"] = this.netSalary;
        data["extraDay"] = this.extraDay;
        data["extraDaySalary"] = this.extraDaySalary;
        data["overtimeHours"] = this.overtimeHours;
        data["overtimeSalary"] = this.overtimeSalary;
        data["extraPay"] = this.extraPay;
        data["finalSalary"] = this.finalSalary;
        data["displayName"] = this.displayName;
        data["designationName"] = this.designationName;
        data["departmentName"] = this.departmentName;
        data["joinDate"] = this.joinDate ? this.joinDate.toISOString() : <any>undefined;
        data["payDate"] = this.payDate ? this.payDate.toISOString() : <any>undefined;
        data["workingDay"] = this.workingDay;
        data["employeeSalaryType"] = this.employeeSalaryType;
        data["paidLeaveCount"] = this.paidLeaveCount;
        data["paidLeaveAmount"] = this.paidLeaveAmount;
        data["incrementAmount"] = this.incrementAmount;
        data["presentDays"] = this.presentDays;
        data["totalTDSAmount"] = this.totalTDSAmount;
        data["payableSalary"] = this.payableSalary;
        data["additionalSalary"] = this.additionalSalary;
        data["empLegalName"] = this.empLegalName;
        data["companyLegalName"] = this.companyLegalName;
        data["companyAddress"] = this.companyAddress;
        data["basicAlw"] = this.basicAlw;
        data["dearnessAlw"] = this.dearnessAlw;
        data["houseRentAlw"] = this.houseRentAlw;
        data["medicalAlw"] = this.medicalAlw;
        data["dailyTravellingAlw"] = this.dailyTravellingAlw;
        data["performanceAlw"] = this.performanceAlw;
        data["otherAlw"] = this.otherAlw;
        data["productionAlw"] = this.productionAlw;
        data["fuelAlw"] = this.fuelAlw;
        data["pfDetectable"] = this.pfDetectable;
        data["esicDetectable"] = this.esicDetectable;
        data["lwfDetectable"] = this.lwfDetectable;
        data["ptDetectable"] = this.ptDetectable;
        data["pfGross"] = this.pfGross;
        data["esicGross"] = this.esicGross;
        data["ptGross"] = this.ptGross;
        data["lwfGross"] = this.lwfGross;
        data["employeeEPFAmount"] = this.employeeEPFAmount;
        data["employeeFPFAmount"] = this.employeeFPFAmount;
        data["companyEPFAmount"] = this.companyEPFAmount;
        data["companyFPFAmount"] = this.companyFPFAmount;
        data["employeeESICAmount"] = this.employeeESICAmount;
        data["companyESICAmount"] = this.companyESICAmount;
        data["employeeLWFAmount"] = this.employeeLWFAmount;
        data["companyLWFAmount"] = this.companyLWFAmount;
        data["pfNo"] = this.pfNo;
        data["pfuan"] = this.pfuan;
        data["esicNo"] = this.esicNo;
        data["aadharNo"] = this.aadharNo;
        data["pan"] = this.pan;
        data["paymentType"] = this.paymentType;
        data["bankName"] = this.bankName;
        data["bankAccNo"] = this.bankAccNo;
        data["ifscCode"] = this.ifscCode;
        data["advancePay"] = this.advancePay;
        data["isSalaryPaid"] = this.isSalaryPaid;
        data["paidAmount"] = this.paidAmount;
        data["salaryCalcDays"] = this.salaryCalcDays;
        data["usedPaidLeaveCount"] = this.usedPaidLeaveCount;
        return data; 
    }
}

export interface IEmployeeMonthlySalaryDto {
    id: number;
    employeeId: number;
    empName: string | undefined;
    empCode: string | undefined;
    salaryMonth: Date | undefined;
    basicSalary: number | undefined;
    absentDays: number | undefined;
    absentSalary: number | undefined;
    professionalTax: number | undefined;
    netSalary: number | undefined;
    extraDay: number | undefined;
    extraDaySalary: number | undefined;
    overtimeHours: number | undefined;
    overtimeSalary: number | undefined;
    extraPay: number | undefined;
    finalSalary: number | undefined;
    displayName: string | undefined;
    designationName: string | undefined;
    departmentName: string | undefined;
    joinDate: Date | undefined;
    payDate: Date | undefined;
    workingDay: number;
    employeeSalaryType: number;
    paidLeaveCount: number | undefined;
    paidLeaveAmount: number | undefined;
    incrementAmount: number | undefined;
    presentDays: number | undefined;
    totalTDSAmount: number | undefined;
    payableSalary: number | undefined;
    additionalSalary: number | undefined;
    empLegalName: string | undefined;
    companyLegalName: string | undefined;
    companyAddress: string | undefined;
    basicAlw: number | undefined;
    dearnessAlw: number | undefined;
    houseRentAlw: number | undefined;
    medicalAlw: number | undefined;
    dailyTravellingAlw: number | undefined;
    performanceAlw: number | undefined;
    otherAlw: number | undefined;
    productionAlw: number | undefined;
    fuelAlw: number | undefined;
    pfDetectable: boolean;
    esicDetectable: boolean;
    lwfDetectable: boolean;
    ptDetectable: boolean;
    pfGross: number | undefined;
    esicGross: number | undefined;
    ptGross: number | undefined;
    lwfGross: number | undefined;
    employeeEPFAmount: number | undefined;
    employeeFPFAmount: number | undefined;
    companyEPFAmount: number | undefined;
    companyFPFAmount: number | undefined;
    employeeESICAmount: number | undefined;
    companyESICAmount: number | undefined;
    employeeLWFAmount: number | undefined;
    companyLWFAmount: number | undefined;
    pfNo: string | undefined;
    pfuan: string | undefined;
    esicNo: string | undefined;
    aadharNo: string | undefined;
    pan: string | undefined;
    paymentType: string | undefined;
    bankName: string | undefined;
    bankAccNo: string | undefined;
    ifscCode: string | undefined;
    advancePay: number | undefined;
    isSalaryPaid: boolean;
    paidAmount: number | undefined;
    salaryCalcDays: number | undefined;
    usedPaidLeaveCount: number | undefined;
}

